import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";

import ListAdministration from "./List";
import CreateAdministration from "./Create";
import EditAdministration from "./Edit";
import ShowAdministration from "./Show";
export const ADMINISTRATION = "users/admin-user";

export const resources = {
  isMenu: true,
  icon: <SupervisorAccountIcon />,
  name: ADMINISTRATION,
  title: "Административни",
  list: <ListAdministration />,
  create: <CreateAdministration />,
  edit: <EditAdministration />,
  show: <ShowAdministration />,
  permission: "administrator",
};
